// page で処理を分けてるけど、page の他にmode とかを作って、
// 例えばメール送信画面かつモードはパスワードリセット
// みたいな処理にしたほうがキレイかもしれない。。。😏
// もしくは素直にreact navigation 使うなど（望月）

export const PAGE = {
  // main content
  LOGIN: 1,
  MAIN: 2,

  // forget password
  CHANGE_PASSWORD: 11,
  CHANGE_PASSWORD_MAIL: 12,

  // register account
  REGISTRATION: 21,
  TERMS_OF_USE: 22,
  REGISTRATION_MAIL: 23,

  // re activation mail send
  REACTIVATION: 31,
  REACTIVATION_MAIL: 32,

  // terms
  TERMS_OF_USE_UPDATE: 91,
};
